import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TaskFile, TaskHistory } from '@app/interfaces/lm/kanban-board';
import { Account } from '@app/interfaces/sys/account';
import { CapitalizeLowerPipe } from '@app/pipe/capitalize-lower.pipe';
import { AccountService } from '@services/sys/account.service';
import dayjs from 'dayjs';
import { STColumn, STData, STScroll } from '@app/interfaces/sys/st';
import { SettingsService } from '@services/sys/settings.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-activity-history',
    templateUrl: './activity-history.component.html',
    styleUrl: './activity-history.component.less',
    providers: [CapitalizeLowerPipe],
})
export class ActivityHistoryComponent implements OnChanges {
    @Input() item: TaskHistory = {} as TaskHistory;
    @Input() accountList: Account[] = [];
    @Input() pluralCategories: string[] = [];
    userData: Account = {} as Account;
    columns: STColumn[] = [
        {
            title: 'File Name',
            index: 'fileName',
            width: '150px',
        },
        {
            title: 'File Size',
            index: 'fileSize',
            format: (item: STData) => {
                return item.fileSize ? this.settingServiced.formatSize(item.fileSize) : '';
            },
            width: '100px',
        },
        {
            title: 'Date Added',
            index: 'createdDate',
            type: 'date',
            dateFormat: 'YYYY-MM-dd HH:mm:ss',
            width: '140px',
        }
    ];
    oldAttachment: TaskFile[] = [];
    newAttachment: TaskFile[] = [];
    oldValue: SafeHtml | string = '';
    newValue: SafeHtml | string = '';
    editorCategory = ['Paragraph'];
    editorFields = ['Description','Comment'];

    constructor(private accountService: AccountService,
                private sanitizer: DomSanitizer,
                private settingServiced: SettingsService) {
    }

    getSafeHtml(html: string): SafeHtml {
        return html ? this.sanitizer.bypassSecurityTrustHtml(html) : '';
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { accountList, item } = changes;
        if (accountList || item) {
            this.userData = this.accountService.formatUserInfo(this.accountList, this.item.userId);
            const fieldCategoryName = this.item?.fieldCategoryName || '';
            const oldValue = this.item?.oldFieldValue || '';
            const newValue = this.item?.newFieldValue || '';
            const fieldName = this.item?.fieldName || '';
            if (fieldCategoryName === 'Attachment') {
                this.oldAttachment = this.getAttachmentList(oldValue);
                this.newAttachment = this.getAttachmentList(newValue);
            }

            if (this.editorCategory.includes(fieldCategoryName) || (!fieldCategoryName && this.editorFields.includes(fieldName))) {
                this.oldValue = oldValue ? this.getSafeHtml(oldValue) : 'None';
                this.newValue = newValue ? this.getSafeHtml(newValue) : 'None';
            } else {
                this.oldValue = this.getValue(oldValue);
                this.newValue = this.getValue(newValue);
            }
        }
    }

    getValue(str: string): string {
        const usersFieldNames = ['Assignees'];
        const fieldName = this.item?.fieldName || '';
        const fieldCategoryName = this.item?.fieldCategoryName || '';
        let value = str || '';
        if (fieldCategoryName === 'User' || usersFieldNames.includes(fieldName)) {
            const arr: string[] = value ? JSON.parse(value) : [];
            value = arr.map(it => this.accountService.formatUserInfo(this.accountList, it)?.name || it).join(', ');
        }
        if (fieldCategoryName === 'Date') {
            value = value ? dayjs(value).format('YYYY-MM-DD') : '';
        }
        if (fieldCategoryName === 'Timestamp') {
            value = value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
        return value || 'None';
    }

    isNone(value:any): boolean {
        const target = {
            "changingThisBreaksApplicationSecurity": "<p><br></p>"
        }
        return JSON.stringify(value) === JSON.stringify(target);;
    }

    getAttachmentList(value: string): TaskFile[] {
        try {
            const jsonArr: Array<string|TaskFile> = value ? JSON.parse(value) : [];
            return jsonArr ? jsonArr.map(it => {
                if (typeof it === 'string') {
                    return JSON.parse(it) as TaskFile;
                }
                return it as TaskFile;
            }) : [];
        } catch (e) {
            return [];
        }
    }

}
